import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Experience',
    href: '#experience'
  }, {
    name: 'Expertise',
    href: '#expertise'
  }, {
    name: 'Recognition',
    href: '#recognition'
  }, {
    name: 'Education',
    href: '#education'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-navy/90 backdrop-blur-md border-b border-gold/30 py-4 shadow-lg' : 'bg-transparent py-6'}`} data-id="element-255">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-256">
        {/* Logo */}
        <a href="#" className="flex items-center gap-3 group" data-id="element-257">
          <span className="font-serif text-2xl text-gold font-semibold tracking-wide group-hover:text-gold-bright transition-colors" data-id="element-258">
            OJ
          </span>
          <span className="hidden sm:block w-px h-6 bg-gold/40" data-id="element-259"></span>
          <span className="hidden sm:block font-sans text-xs uppercase tracking-widest text-white/90 font-medium" data-id="element-260">
            Ole Jensen
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-261">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-white/80 hover:text-gold text-sm font-medium tracking-wide transition-colors relative after:content-[''] after:absolute after:-bottom-1 after:left-0 after:w-0 after:h-[1px] after:bg-gold hover:after:w-full after:transition-all after:duration-300" data-id="element-262">
              {link.name}
            </a>)}
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden text-white hover:text-gold transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-263">
          {isMobileMenuOpen ? <XIcon size={24} data-id="element-264" /> : <MenuIcon size={24} data-id="element-265" />}
        </button>
      </div>

      {/* Mobile Nav Drawer */}
      <AnimatePresence data-id="element-266">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="lg:hidden absolute top-full left-0 right-0 bg-navy border-b border-gold/30 shadow-xl" data-id="element-267">
            <nav className="flex flex-col px-6 py-4" data-id="element-268">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-white/80 hover:text-gold py-4 border-b border-white/5 text-sm font-medium tracking-widest uppercase transition-colors" data-id="element-269">
                  {link.name}
                </a>)}
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}